module.exports = __webpack_public_path__ + "static/media/illo_review.aa6d3304.svg";